import  {firebaseConfig}  from "./firebaseConfig";
import firebase from "firebase"


firebase.initializeApp(firebaseConfig)
export const databaseRef = firebase.firestore();
export const googleProvider = firebase.auth.GoogleAuthProvider.PROVIDER_ID;
export const firebaseAuth = firebase.auth();
export const dashboardRef = databaseRef.collection("Dashboard");
export const roomRef = databaseRef.collection("Room");